<template>
  <div class="container">
    
    <div class="text-center community-title-component">
      <strong class="community-title">
        {{ $t('community_page.title') }}
      </strong>
    </div>

    <div class="community-filters">
      <div 
        class="community-filters-left" 
        style="gap: 20px;"
      >
        <select 
          v-model="ageRange" 
          class="registration-input registration-input--select community-filters-select" 
          name="Age range"
        >
          <option :value="null">{{ $t('community_page.all_ages') }}</option>
          <option value="0-17">0-17</option>
          <option value="18-24">18-24</option>
          <option value="25-34">25-34</option>
          <option value="35-44">35-44</option>
          <option value="45-54">45-54</option>
          <option value="55-64">55-64</option>
          <option value="65+">65+</option>
        </select>
        <select
          v-model="gender"
          class="registration-input registration-input--select community-filters-select" 
          name="Gender"
        >
          <option :value="null">{{ $t('community_page.all_genders') }}</option>
          <option value="M">{{ $t('community_page.male') }}</option>
          <option value="F">{{ $t('community_page.female') }}</option>
        </select>
        <details 
          class="community-filters-multiselect"
          ref="categoryDetails"
        >
          <summary style="width: 100%; display: flex; justify-content: space-between;">
            <div>
              {{ $t('community_page.categories') }}
            </div>
            <div>
              <svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>
            </div>
          </summary>
          <div class="community-filters-multiselect-dropdown-panel">
            <div class="community-filters-multiselect-form">
              <fieldset class="community-filters-multiselect-fieldset">
                <ul class="community-filters-multiselect-list">
                  <li
                  >
                    <div
                      @click="professionsChosen = []"
                      style="cursor: pointer;"
                      
                    >
                      {{ $t('community_page.all_categories') }}
                    </div>
                  </li>
                  <li>
                    <b-form-checkbox-group
                      id="professions-group"
                      v-model="professionsChosen"
                      name="professions"
                      stacked
                    >
                      <b-form-checkbox
                        v-for="profession in professions"
                        :key="profession" 
                        :value="profession"
                      >
                        {{profession}}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </li>
                </ul>
              </fieldset>
            </div>
          </div>

        </details>

        <button
          class="profile-delete-button community-filters-select-filter-button"
          @click="filterVideos"
        >
          {{ $t('community_page.filter') }}
        </button>

        <!--<select 
          v-if="!onlyLiked"
          @change="filterVideos"
          v-model="profession" 
          class="registration-input registration-input--select community-filters-select" 
          name="Profession"
        >
          <option :value="null">All categories</option>
          <option
            v-for="profession in professions"
            :key="profession"
            :value="profession"
          >
            {{ profession }}
          </option>  
        </select>-->
      </div>
      <button
        class="profile-delete-button community-filters-select-favorite"
        @click="clickOnLike"
      >
        <span>
          {{ onlyLiked ? $t('community_page.all_profiles') : $t('community_page.favorite_profiles_only') }}
        </span>
      </button>
    </div>

    <div class="row">
      <div 
        v-for="privatePerson in privatePersons"
        :key="privatePerson.id"
        class="col-12 col-md-3 mt-4"
      >
        <PrivatePersonItem
          @click-on-like="likePrivatePerson(privatePerson)"
          @click-on-profile="clickOnProfile(privatePerson)"
          @click-on-whatsapp="clickOnWhatsapp(privatePerson)"
          :chosen-profile="chosenProfile"
          :private-person="privatePerson"
          :userId="Number(userId)"
        />
      </div>
    </div>

    
    <div class="profile-footer">
      <div 
        @click='$router.go(-1)'
        class="profile-back-pc-button"
      >
        <img
          src="@/assets/images/button/back/back_pc.svg"
          :alt="$t('community_page.back')"
        />
      </div>
      <button
        v-if="hasMore" 
        class="profile-validation-button"
        @click="nextPrivatePersons"
      >
        {{ $t('community_page.more_members') }}
      </button>
    </div>

  </div>
</template>

<script>
import { APIPrivatePerson } from '@/api/APIPrivatePerson'
import { APIUserConnected } from '@/api/APIUserConnected'
import PrivatePersonItem from '@/components/privateperson/PrivatePersonItem.vue'
import { mobileDetectionMixins } from '@/mixins/mobileDetection'
import { privatePersonMixins } from '@/mixins/privatePersonMixins'

const apiPrivatePerson = new APIPrivatePerson()
const apiUserConnected = new APIUserConnected()

export default {
  name: 'LearnPage',
  mixins: [privatePersonMixins, mobileDetectionMixins],
  components: {
    PrivatePersonItem,
  },
  data() {
    return {
      ageRange: null,
      chosenProfile: null,
      gender: null,
      hasMore: false,
      onlyLiked: false,
      page: 1,
      privatePersons: [],
      professionsChosen: [],
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    userId () {
      return this.$store.state.user.userPk
    }
  },
  async mounted () {
    this.getPrivatePersons()
  },
  async created() {
    this.$store.commit('loadFromAPI')
    await this.getPrivatePersons()
    this.$store.commit('endLoadingFromAPI')
  },
  methods: {
    clickOnLike () {
      if (this.isAuthenticated) {
        this.onlyLiked = !this.onlyLiked
        if (this.onlyLiked) {
          this.getPrivatePersonsLiked()
        } else {
          this.getPrivatePersons()
        }
      } else {
        this.$store.commit('set', ['loginModalNotRedirect', true])
        this.$store.commit('openLoginModal')
      }
    },
    clickOnProfile (privatePerson) {
      console.log('clickOnProfile', privatePerson)
      if (this.chosenProfile && this.chosenProfile.id === privatePerson.id) {
        this.chosenProfile = null
        return
      }
      else {
        this.chosenProfile = privatePerson
      }
    },
    clickOnWhatsapp (privatePerson) {
      // Open whatsapp with the phone number of the private person
      const phoneNumber = privatePerson.phone_number
      const url = `https://api.whatsapp.com/send?phone=${phoneNumber}`
      window.open(url, '_blank')
    },
    filterVideos () {
      this.$refs.categoryDetails.open = false;
      if (this.onlyLiked) {
        this.getPrivatePersonsLiked()
      } else {
        this.getPrivatePersons()
      }
    },
    getPrivatePersons (isNext=false) {
      this.$store.commit('loadFromAPI')
      const data = {
        ageRange: this.ageRange,
        gender: this.gender,
        professions: this.professionsChosen,
        page: this.page,
      }
      apiPrivatePerson.getPrivatePersons(data)
      .then((result) => {
        console.log(result)
        this.hasMore = result.data['hasMore']
        this.privatePersons = isNext ? this.privatePersons.concat(result.data['privatePersons']) : result.data['privatePersons']
      })
      .catch((error) => {
        throw new Error('getVideos getAds API Error : ' + String(error))
      })
      .finally(() => {
        this.$store.commit('endLoadingFromAPI')
      })
    },
    getPrivatePersonsLiked (isNext=false) {
      this.$store.commit('loadFromAPI')
      const data = {
        ageRange: this.ageRange,
        gender: this.gender,
        professions: this.professionsChosen,
        page: this.page,
      }
      apiUserConnected.getPrivatePersonsLiked(data)
      .then((result) => {
        this.hasLoaded = true
        // translate newsletters
        this.hasMore = result.data['hasMore']
        this.privatePersons = isNext ? this.privatePersons.concat(result.data['privatePersons']) : result.data['privatePersons']
      })
      .catch((error) => {
        throw new Error('ProspectsList getProspects API Error : ' + String(error))
      })
      .finally(() => {
        this.$store.commit('endLoadingFromAPI')
      })
    },
    likePrivatePerson (privatePerson) {
      // if not connected
      if (!this.isAuthenticated) {
        this.$store.commit('set', ['loginModalNotRedirect', true])
        this.$store.commit('openLoginModal')
        return
      }
      this.$store.commit('loadFromAPI')
      apiUserConnected.likePrivatePerson(privatePerson.id)
      .then(() => {
        this.privatePersons = this.privatePersons.map((item) => {
          if (item.id === privatePerson.id) {
            if (item.likes.includes(Number(this.userId))) {
              item.likes = item.likes.filter((item) => item !== Number(this.userId))
            } else {
              item.likes.push(Number(this.userId))
            }
          }
          return item
        })
      })
      .catch((error) => {
        throw new Error('NewslettersView likeNewsletter API Error : ' + String(error))
      })
      .finally(() => {
        this.$store.commit('endLoadingFromAPI')
      })
    },
    nextPrivatePersons () {
      this.page += 1
      if (this.onlyLiked) {
        this.getPrivatePersonsLiked(true)
      } else {
        this.getPrivatePersons(true)
      }
    },
    toggleProfession (event) {
      const profession = event.target.value
      if (this.professionsChosen && this.professionsChosen.includes(profession)) {
        this.professionsChosen = this.professionsChosen.filter((item) => item !== profession)
      } else {
        this.professionsChosen = this.professionsChosen ? [...this.professionsChosen, profession] : [profession]
      }
    },
  },
}
</script>

<style>
.community-title-component {
  margin-top: 30px;
}
.community-title {
  font-size: 30px;
  margin-top: 20px;
}
.community-filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;  
  margin-top: 30px;
  margin-bottom: 10px;
  gap: 20px;
}

@media screen and (max-width: 768px) {
  .community-filters {
    flex-direction: column;
    align-items: flex-start;
  } 
}

.community-filters-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;  
  width: 100%;
}
@media screen and (min-width: 768px) {
  .community-filters-left {
    flex-direction: row;
    justify-content: flex-start;
  } 
}

.community-filters-select {
  height: 50px;
  padding-left: 5px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .community-filters-select {
    width: 150px;
  }
}

.community-filters-select-favorite {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .community-filters-select-favorite {
    width: 350px;
  }
}

.community-filters-select-filter-button {
  border-radius: 20px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .community-filters-select-filter-button {
    width: 100px;
  }
}


.community-filters-multiselect {
  border: 1px solid #D9D9D8;
  border-radius: 5px;
  position: relative;
  display: flex; 
  align-items: center;
  padding-left: 3px;
  height: 50px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .community-filters-multiselect {
    width: 150px;
  }
}

.community-filters-multiselect-dropdown-panel {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: white;
  border: 1px solid #767676;
  border-radius: 3px;
  padding: 8px;
  min-width: 250px;
}

/* Show panel only when <details> is open */
.community-filters-multiselect[open] .dropdown-panel {
  display: block;
}



.community-filters-multiselect summary::marker {
  display: none;
  font-size: 0;
}

.community-filters-multiselect summary::-webkit-details-marker {
  display: none;
  font-size: 0;
}

.community-filters-multiselect-form {
  display: flex; 
}

.community-filters-multiselect-fieldset {
  border: 0;
  padding: 0;
  width: 100%;
}

.community-filters-multiselect-legend {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.community-filters-multiselect-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.community-filters-multiselect-list li {
  border-radius: 3px;
  margin: 0;
  padding: 4px 2px;
}

.community-filters-multiselect-list li label {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}
</style>